export default {
  type: 'Typ',
  relevanceNo: 'Zugehörige Bestellnummer',
  consultContent: 'Beratungsinhalt',
  submitTime: 'Einreichungszeit',
  consultTypeEnum: {
    0: 'Bestellanfrage',
    1: 'Paketberatung',
  },
  consultStatusEnum: {
    0: 'unbearbeitet',
    1: 'in Bearbeitung',
    2: 'abgeschlossen',
  },
}
